import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { hasAppTransientHistoryMarker } from '@core/models/app-history.model';

@Injectable({ providedIn: 'root' })
export class ExternalNavigationService {
  private readonly document = inject(DOCUMENT);
  private pendingReplaceUrl: string | null = null;

  replace(url: string): void {
    const appWindow = this.document.defaultView;
    if (appWindow && hasAppTransientHistoryMarker(appWindow.history.state)) {
      const traversalPending = this.pendingReplaceUrl !== null;
      this.pendingReplaceUrl = url;
      if (traversalPending) {
        return;
      }
      appWindow.addEventListener('popstate', this.replaceAfterMarker, {
        once: true,
      });
      appWindow.history.back();
      return;
    }

    this.document.location.replace(url);
  }

  private readonly replaceAfterMarker = (): void => {
    const url = this.pendingReplaceUrl;
    this.pendingReplaceUrl = null;
    if (url) {
      this.document.location.replace(url);
    }
  };
}
